const createConfirmImageUploadUseCase = (repository) => async (data) => {
    try {
        return await repository(data);
    } catch (err) {
        throw err
    }
}

export default createConfirmImageUploadUseCase;